import { Subtitle } from '@tremor/react';
import { ClipLoader } from 'react-spinners';
import s from './LoadingIndicator.module.scss';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  awaitingEntity?: string;
  isDeleting?: boolean;
  wholeMessage?: string;
  isLoading?: boolean;
}

export default function LoadingIndicator({
  awaitingEntity = 'organization',
  isDeleting,
  children,
  wholeMessage,
  isLoading = true,
}: Props) {
  const message = isDeleting ? 'deleting' : 'preparing';

  return (
    <section className={s.preparingSection}>
      {isLoading ? (
        <ClipLoader
          size={80}
          color="#BA2634"
          speedMultiplier={0.9}
          cssOverride={{ borderWidth: '4px' }}
        />
      ) : null}
      <Subtitle>
        {wholeMessage
          ? wholeMessage
          : `We are ${message} Your ${awaitingEntity}. It may take couple minutes. You may close this window and come back later`}
      </Subtitle>
      {children}
    </section>
  );
}
